import script from "./LoanRepaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanRepaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./LoanRepaymentForm.vue?vue&type=style&index=0&id=5d26a576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d26a576"]])

export default __exports__